import styled from 'styled-components';

export const StyledModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  display: flex;
  width: 500px;
  padding: 32px;
  flex-direction: column;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.success4};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);

  > svg {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 12px;
    top: 12px;
    cursor: pointer;

    path {
      fill: ${({ theme }) => theme.color.grey500};
    }
  }
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    > p {
      color: ${({ theme }) => theme.color.grey900};
      text-align: center;
      margin: 12px 0 32px 0;
      font-feature-settings: 'clig' off, 'liga' off;
      font-family: AcidGrotesk-Bold;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: 0.2px;
    }

    > button {
      width: 120px;
      background: ${({ theme }) => theme.color.white};
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  button {
    width: 140px;
    padding: 12px 24px;
    white-space: nowrap;

    &:last-child {
      margin-left: 20px;
    }
  }
`;
